import { creatorFetch } from './creatorFetch.ts';
import { apiV1Url } from '../lib/apiBaseUrl.ts';

type PfHealth = {
  overall?: 'green' | 'yellow' | 'red' | string;
  statuses?: Record<string, string>;
};

type Options = {
  maxWaitMs?: number;
  pollIntervalMs?: number;
  onProgress?: (message: string) => void;
};

/**
 * Warm up / ensure reachability of instruction-flow services behind the backend.
 * This mitigates ACA cold-start / scale-to-zero latency.
 */
export async function ensurePfReady(options: Options = {}): Promise<PfHealth> {
  const maxWaitMs = options.maxWaitMs ?? 45000;
  const pollIntervalMs = options.pollIntervalMs ?? 2000;
  const startedAt = Date.now();

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const elapsed = Date.now() - startedAt;
    if (elapsed > maxWaitMs) {
      return { overall: 'red' };
    }

    options.onProgress?.('Starting AI processor… (cold start)');
    try {
      const res = await creatorFetch(apiV1Url('/api/v1/pf-health'), { method: 'GET' });
      if (res.ok) {
        const data = (await res.json()) as PfHealth;
        if (data?.overall === 'green') return data;
      }
    } catch {
      // ignore transient failures while warming up
    }

    await new Promise((r) => setTimeout(r, pollIntervalMs));
  }
}

